<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16.158" height="15.825" viewBox="0 0 16.158 15.825">
    <path class="back-button-icon" d="M19,11H7.83l4.88-4.88a1.008,1.008,0,0,0,0-1.42,1,1,0,0,0-1.41,0L4.71,11.29a1,1,0,0,0,0,1.41l6.59,6.59a1,1,0,0,0,1.41-1.41L7.83,13H19a1,1,0,0,0,0-2Z" transform="translate(-4.092 -4.082)" fill="#2699fb" stroke="#2699fb" stroke-width="0.5"/>
  </svg>
</template>

<script>
  export default {
    name: 'BackButtonIcon'
  }
</script>

<style lang="scss">
  
</style>